function GradientIcon({ type, className = '' }) {
  const gradientId = `gradient-${type}`;
  
  const icons = {
    brain: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M12 2C8.5 2 6 4.5 6 8c0 2 1 3.5 2 4.5v2c0 1.5 1.5 3 3 3s3-1.5 3-3v-2c1-1 2-2.5 2-4.5 0-3.5-2.5-6-6-6z" fill={`url(#${gradientId})`} />
        <path d="M9 12c-1 0-2 1-2 2v1c0 1 1 2 2 2h6c1 0 2-1 2-2v-1c0-1-1-2-2-2H9z" fill={`url(#${gradientId})`} opacity="0.7" />
      </svg>
    ),
    target: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="10" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <circle cx="12" cy="12" r="6" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <circle cx="12" cy="12" r="2" fill={`url(#${gradientId})`} />
      </svg>
    ),
    gift: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <rect x="3" y="8" width="18" height="12" rx="1" fill={`url(#${gradientId})`} />
        <path d="M12 8V3M12 8H7M12 8H17M7 3h10v5H7V3z" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M8 8v12M16 8v12" stroke={`url(#${gradientId})`} strokeWidth="2" />
      </svg>
    ),
    lightning: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill={`url(#${gradientId})`} />
      </svg>
    ),
    books: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" fill={`url(#${gradientId})`} />
        <path d="M8 7h8M8 11h8M8 15h4" stroke="white" strokeWidth="1.5" />
      </svg>
    ),
    sparkles: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill={`url(#${gradientId})`} />
        <circle cx="6" cy="6" r="1.5" fill={`url(#${gradientId})`} />
        <circle cx="18" cy="18" r="1.5" fill={`url(#${gradientId})`} />
        <circle cx="18" cy="6" r="1.5" fill={`url(#${gradientId})`} />
        <circle cx="6" cy="18" r="1.5" fill={`url(#${gradientId})`} />
      </svg>
    ),
    checkmark: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
        <path d="M4 10l4 4 8-8" stroke="#06B6D4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    diamond: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M12 2L15 9L22 10L15 11L12 18L9 11L2 10L9 9L12 2Z" fill={`url(#${gradientId})`} />
      </svg>
    ),
    crown: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M5 16L3 7l5.5 3L12 4l3.5 6L21 7l-2 9H5zm0 0h14v2H5v-2z" fill={`url(#${gradientId})`} />
        <circle cx="7" cy="12" r="1" fill="white" opacity="0.8" />
        <circle cx="12" cy="10" r="1" fill="white" opacity="0.8" />
        <circle cx="17" cy="12" r="1" fill="white" opacity="0.8" />
      </svg>
    ),
    plate: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <ellipse cx="12" cy="15" rx="8" ry="3" fill={`url(#${gradientId})`} />
        <path d="M4 15c0-4 3.5-7 8-7s8 3 8 7" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <circle cx="12" cy="12" r="6" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
      </svg>
    ),
    handshake: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M9 11l-2-2c-1-1-1-3 0-4l3-3c1-1 3-1 4 0l2 2" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M15 13l2 2c1 1 1 3 0 4l-3 3c-1 1-3 1-4 0l-2-2" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M8 12l8 8M16 12l-8 8" stroke={`url(#${gradientId})`} strokeWidth="2" />
      </svg>
    ),
    speech: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" fill={`url(#${gradientId})`} />
        <circle cx="9" cy="10" r="1" fill="white" />
        <circle cx="15" cy="10" r="1" fill="white" />
      </svg>
    ),
    muscle: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M12 2C8 2 5 5 5 9c0 2 1 4 3 5v6c0 2 2 4 4 4s4-2 4-4v-6c2-1 3-3 3-5 0-4-3-7-7-7z" fill={`url(#${gradientId})`} />
        <path d="M9 8h6M9 12h6" stroke="white" strokeWidth="1.5" />
      </svg>
    ),
    close: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="10" fill={`url(#${gradientId})`} />
        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
    search: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <circle cx="11" cy="11" r="7" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M16 16l4 4" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    clock: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="10" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M12 6v6l4 2" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    moon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill={`url(#${gradientId})`} />
      </svg>
    ),
    fire: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" fill={`url(#${gradientId})`} />
      </svg>
    ),
    calendar: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3ae6fc" />
            <stop offset="100%" stopColor="#02434b" />
          </linearGradient>
        </defs>
        <rect x="3" y="4" width="18" height="18" rx="2" stroke={`url(#${gradientId})`} strokeWidth="2" fill="none" />
        <path d="M3 10h18M8 2v4M16 2v4" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" />
        <circle cx="9" cy="15" r="1" fill={`url(#${gradientId})`} />
        <circle cx="15" cy="15" r="1" fill={`url(#${gradientId})`} />
      </svg>
    )
  };

  return icons[type] || null;
}

export default GradientIcon;

